import { ReactElement, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSnapshot } from 'valtio';
import { Role, roleStore } from '../../store/roleStore';
import { useHostAccountGuard } from '../hooks/useHostAccountGuard';

/**
 * Paused host (D41): a hosting tool page opened in host mode (link, URL or refresh)
 * re-checks the host account with the server. A paused or no longer approved host
 * gets the "Host account paused" modal and goes back to My listings, where the cars
 * show greyed out. The page renders while the check runs, and a failed check keeps
 * it (a flaky network never locks a host out). Admin and guest modes are not checked,
 * so an admin managing a host's car is never sent away.
 */
export function HostAccountRoute({ children }: { children: ReactElement }) {
  const { role } = useSnapshot(roleStore);
  const { guard } = useHostAccountGuard();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (role !== Role.HOST) return undefined;
    let cancelled = false;
    void guard(() => {}).then(ran => {
      if (!ran && !cancelled) navigate('/cars/host', { replace: true });
    });
    return () => {
      cancelled = true;
    };
  }, [role, pathname, guard, navigate]);

  return children;
}

export default HostAccountRoute;
